import React, {Component} from 'react';
import './Footer.css';

class Footer extends Component {
  render() {
    return (
      <footer id="page-footer" className="page-footer"><div className="l-wrapper"><div className="l-gutter"><div className="footer-contact">
      <ul className="footer-contact__left">
      <li><a href="//vcu.edu" title="Virginia Commonwealth University" aria-label="Visit vcu.edu">Virginia Commonwealth University</a></li>
      <li><a href="//president.vcu.edu" title="Office of the President">Office of the President</a></li>
      <li>
      <address>
      Box 842512<br />
      Richmond, Virginia 23284-2512<br />
      </address>
      </li>
      <li><a href="tel:8048281200" title="Contact us by telephone">(804) 828-1200</a></li>
      <li><a href="mailto:president@vcu.edu" title="Contact us by email">president@vcu.edu</a></li>
      </ul>
      <div className="footer-contact__right">
      <ul className="footer-contact__right-social">
      <li><a href="//facebook.com/virginiacommonwealthuniversity"><i className="fab fa-facebook-f"><span className="sr-only">VCU Facebook</span></i></a></li>
      <li><a href="//twitter.com/VCU"><i className="fab fa-twitter"><span className="sr-only">Visit Twitter for VCU</span></i></a></li>
      <li><a href="//youtube.com/user/VCU"><i className="fab fa-youtube"><span className="sr-only">Visit YouTube for VCU</span></i></a></li>
      <li><a href="//linkedin.com/edu/school?id=19608&trk=tyah"><i className="fab fa-linkedin"><span className="sr-only">Visit LinkedIn for VCU</span></i></a></li>
      <li><a href="//instagram.com/vcu"><i className="fab fa-instagram"><span className="sr-only">Visit instagram for VCU</span></i></a></li>
      </ul>
      </div>
      </div>
      <div className="footer-contact__standards">
      <ul className="footer-contact__standards-list">
        <li><a title="Report archive" href="../archive/index.html" target="_blank" rel="noopener noreferrer">Report archive</a></li>
      </ul>
      <ul className="footer-contact__standards-list">
      <li><a title="VCU privacy statement" href="//www.vcu.edu/vcu/privacy-statement.html" target="_blank" rel="noopener noreferrer">Privacy</a></li>
      <li><a title="Accessibility at VCU" href="//accessibility.vcu.edu/" target="_blank" rel="noopener noreferrer">Accessibility</a></li>
      <li><a title="Contact the VCU webmaster" href="mailto:webmaster@vcu.edu" target="_blank" rel="noopener noreferrer">Webmaster</a></li>
      <li><a href="./text-only.html">View text version</a></li>
      <li>Created by&nbsp;<a href="//www.univrelations.vcu.edu/" title="VCU Univeristy Relations">VCU University Relations</a></li>
      <li>Updated 12/5/2018</li>
      </ul>
      </div></div></div></footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js